import React from 'react';
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import CustomerAvatar from 'components/CustomerAvatar';
import ConnectionStatus from 'components/Common/ConnectionStatus';
import MenuMobile from 'components/MenuMobile';
import PoweredBy from 'components/PoweredBy';
import LocalisedMessage from 'components/Common/LocalisedMessage';
import LanguageSelector from 'components/LanguageSelector';

const contains = (intl, messageId) => intl && intl.messages && !!intl.messages[messageId];

const Header = ({ intl, isAuthenticated, languages, showMenu, isLogoutEnabled, isOnline, fullDictionaryLoaded }) => <header className={ `header ${ isOnline ? '' : 'offline' }` }>
  <div className="row m-0">
    <div className="row m-0 col-2 col-sm-3 col-md-4">
      <div className="col-md-2 p-0">
        { !isLogoutEnabled && isAuthenticated && <Link to="/form-selection" className="btn btn-link">
          <FontAwesomeIcon icon="home" size="lg" />
        </Link>}
        { isAuthenticated && fullDictionaryLoaded && isLogoutEnabled && showMenu && <MenuMobile showLogout={ isAuthenticated && isLogoutEnabled } /> }
      </div>
      { isAuthenticated && showMenu && <CustomerAvatar />}
    </div>
    <div className="col-8 col-sm-6 col-md-4 logo">
      <div className="logo" id="taina-logo" />
      <PoweredBy />
    </div>
    <div className="col-1 col-sm-3 col-md-2 text-right text-md-right">
      { contains(intl, 'header.help') && <React.Fragment>
        <a href={ intl.messages['header.help'] } target="_blank" rel="noopener noreferrer" className="help-link" title={ intl.messages['header.help.tooltip'] }>
          <FontAwesomeIcon icon="question-circle" size="2x" />
        </a>
        <span className="support-link"><LocalisedMessage id="header.help.iconText" /></span>
      </React.Fragment> }
    </div>
    { languages && languages?.length > 1 && <div className="col-12 col-md-2 text-center text-md-right language-selector-section">
      <LanguageSelector languages={ languages } />
    </div> }
  </div>
  <ConnectionStatus><LocalisedMessage id="connectionStatus.banner.offline" /></ConnectionStatus>
</header>;

Header.propTypes = {
  intl: PropTypes.shape({
    messages: PropTypes.any
  }).isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
  languages: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string,
      value: PropTypes.string
    })
  ),
  showMenu: PropTypes.bool,
  isLogoutEnabled: PropTypes.bool,
  isOnline: PropTypes.bool,
  fullDictionaryLoaded: PropTypes.bool
};

Header.defaultProps = {
  languages: [{
    key: 'en',
    value: 'English'
  }],
  isLogoutEnabled: false,
  isOnline: true,
  showMenu: true,
  fullDictionaryLoaded: false
};

const mapDispatchToProps = dispatch => ({ dispatch });

function mapStateToProps(state, ownProps) {
  const {
    app: {
      isAuthenticated,
      languages,
      onlineConfig,
      isOnline,
      fullDictionaryLoaded
    }
  } = state;

  return {
    isAuthenticated,
    isOnline,
    languages,
    fullDictionaryLoaded,
    isLogoutEnabled: onlineConfig && onlineConfig.isLogoutEnabled
  };
}

export default injectIntl(connect(
  mapStateToProps,
  mapDispatchToProps
)(Header));
